import React from 'react';
import JobList from '../components/JobList';
import AdminLayout from 'cms/core/shared/AdminLayout';

function JobScreen() {
  return (
    <AdminLayout pageTitle="Jobs">
      <JobList />
    </AdminLayout>
  );
}

export default JobScreen;